import React from 'react';
import PropTypes from 'prop-types';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { EmailLeadForm } from '@dmm/lib-react-ui-components';

import { useBdpForm } from '../MainContent/bdpController/useBdpForm';
import { syncTranslationElements } from '../../../utils/translations/translationsSync';
import { nil } from '../../../utils/runOnceHelper';
import { bdpFormMessages } from '../utils/bdpParsers';

const BDPEmailLeadForm = ({
  listing,
  portal,
  idPrefix,
  onSuccess = nil,
  onError = nil
}) => {
  const translator = syncTranslationElements();
  const { messages, t } = translator;
  const { leadFormFields, leadFormHandlers, invalidFields } = useBdpForm(
    listing,
    portal,
    translator,
    idPrefix,
    onSuccess,
    onError
  );
  const { sellerNameField, nameField, emailField, phoneField, textField } =
    leadFormFields;
  const { handleSubmit, showSuccess, showError } = leadFormHandlers;
  const emailFormMessages = bdpFormMessages(t, messages);
  return (
    <>
      <div data-testid="email-lead-form" className="email-lead-form">
        <EmailLeadForm
          sellerName={sellerNameField}
          name={nameField}
          email={emailField}
          phone={phoneField}
          textarea={textField}
          invalidFields={invalidFields}
          invalidMessage={`* ${t(messages.contactForm.formError)}`}
          showSuccessMessage={showSuccess}
          showErrorMessage={showError}
          onSubmit={handleSubmit}
          {...emailFormMessages}
        ></EmailLeadForm>
      </div>
    </>
  );
};

BDPEmailLeadForm.defaultProps = {
  listing: {},
  idPrefix: ''
};

BDPEmailLeadForm.propTypes = {
  listing: listingPropTypes,
  idPrefix: PropTypes.string,
  portal: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
};

export default BDPEmailLeadForm;
